import axios from 'axios'
import env from '../variables/EndpointEnvironment'

const BannerAPI = (props) => {
  return axios.get(`${env.HOST}/banners?loc=${props.loc}`, {
    headers: {
      'Content-Language': localStorage.getItem('i18nextLng'),
    },
  })
}

export default BannerAPI
